import executeSeeds from "./execute-seeds.js";
import syncLocales from "./sync-locales.js";
import syncCollections from "./sync-collections.js";

export default {
	executeSeeds,
	syncLocales,
	syncCollections,
};
